import { useCallback, useState } from 'react';
import { Point, Size, pinSizeInPixels, pinTopLeftFromTip, tipFromPinTopLeft, toPinFraction } from './utils';

type UsePinPositionResult = {
    imageSize: Size;
    pinSize: Size;
    pinTopLeft: Point;
    fraction: Point;
    handleImageLoad: (size: Size) => void;
    handleDragStop: (_e: unknown, data: { x: number; y: number }) => void;
    reset: () => void;
};

const EMPTY_SIZE: Size = { width: 0, height: 0 };
const ORIGIN: Point = { x: 0, y: 0 };

export function usePinPosition(sizeFraction: number): UsePinPositionResult {
    const [imageSize, setImageSize] = useState<Size>(EMPTY_SIZE);
    const [tip, setTip] = useState<Point>(ORIGIN);

    const pinSize = pinSizeInPixels(imageSize, sizeFraction);

    const handleImageLoad = useCallback((size: Size) => {
        setImageSize(size);
        setTip({ x: size.width / 2, y: size.height / 2 });
    }, []);

    function handleDragStop(_e: unknown, data: { x: number; y: number }) {
        setTip(tipFromPinTopLeft({ x: data.x, y: data.y }, pinSize));
    }

    const reset = useCallback(() => {
        setImageSize(EMPTY_SIZE);
        setTip(ORIGIN);
    }, []);

    return {
        imageSize,
        pinSize,
        pinTopLeft: pinTopLeftFromTip(tip, pinSize),
        fraction: toPinFraction(tip, imageSize),
        handleImageLoad,
        handleDragStop,
        reset
    };
}
